import { collection, doc, getDoc, getDocs, onSnapshot } from "firebase/firestore";
import { db, dbAccounts } from "../../../backend/firebaseConfig";

const COLLECTION_NAME = "Commission Split Events";

export const subscribeCommissionSplitEvents = (onData, onError) =>
  onSnapshot(
    collection(dbAccounts, COLLECTION_NAME),
    (snapshot) =>
      onData(snapshot.docs.map((eventDocument) => ({
        id: eventDocument.id,
        ...eventDocument.data(),
      }))),
    onError,
  );

export const loadCommissionSplitAdvisers = async () => {
  const advisersSnapshot = await getDocs(
    collection(db, "Authorized Members", "Advisers", "Data"),
  );

  return Promise.all(
    advisersSnapshot.docs.map(async (adviserDocument) => {
      const adviser = adviserDocument.data() || {};
      const personalSnapshot = await getDoc(
        doc(
          db,
          "Authorized Members",
          "Advisers",
          "Data",
          adviserDocument.id,
          "Personal Details",
          "Data",
        ),
      );
      const personal = personalSnapshot.exists() ? personalSnapshot.data() : {};
      const email =
        adviser.email || personal.emailAddress || adviserDocument.id;
      const name = [
        personal.preferredName || personal.forename || personal.firstName,
        personal.surname || personal.lastName,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      return {
        id: adviserDocument.id,
        email,
        name: name || adviser.name || adviser.displayName || email,
      };
    }),
  );
};
